import { useQuery } from '@tanstack/react-query'
import type { z } from 'zod'

import { httpService } from '@/api/v1/http.service'
import { type SelectOption } from '@/components/Select/Select'
import { arrayOfOptions } from '@/utils/zod'

const responseSchema = arrayOfOptions

const parseResponse = (
  response: z.infer<typeof responseSchema>
): SelectOption<string>[] => response

const useAbsencesStatusOptions = () =>
  useQuery({
    queryKey: ['panelAbsencesOptionsStatusList'],
    staleTime: 60 * 100,
    queryFn: async () => {
      const statusOptions =
        await httpService.panel.panelAbsencesOptionsStatusList({
          page_size: 'max'
        })

      return parseResponse(responseSchema.parse(statusOptions.results))
    }
  })

export default useAbsencesStatusOptions
